import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../i18n/LanguageContext";
import { ASSETS } from "../assets";

export const CtaBand = () => {
  const { t } = useLanguage();
  return (
    <section
      className="relative w-full overflow-hidden bg-black py-24 md:py-32"
      data-testid="cta-band-section"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,140,0,0.18),transparent_60%)]" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-400/40 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-orange-400/40 to-transparent" />

      <div className="relative mx-auto flex max-w-5xl flex-col items-center px-6 text-center md:px-12">
        <motion.img
          src={ASSETS.logos.rebel}
          alt="REBEL"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mb-8 w-[220px] drop-shadow-[0_0_40px_rgba(255,140,0,0.4)] md:w-[300px]"
        />
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-4xl font-black tracking-tighter text-white md:text-5xl lg:text-6xl"
          data-testid="cta-band-title"
        >
          {t.cta_band.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-5 max-w-xl text-base text-white/55 md:text-lg"
        >
          {t.cta_band.subtitle}
        </motion.p>
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.3 }}
          onClick={() => document.getElementById("trendia")?.scrollIntoView({ behavior: "smooth" })}
          className="group relative mt-10 inline-flex items-center gap-2 overflow-hidden rounded-full bg-gradient-to-r from-orange-500 to-amber-600 px-8 py-4 text-base font-bold text-black transition-all hover:-translate-y-0.5 hover:shadow-[0_0_50px_rgba(255,140,0,0.65)]"
          data-testid="cta-band-button"
        >
          <span className="relative z-10">{t.cta_band.button}</span>
          <span className="relative z-10 transition-transform group-hover:translate-x-1">→</span>
          <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/35 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
        </motion.button>
      </div>
    </section>
  );
};
